module.exports = __webpack_public_path__ + "static/testimonial-quicka-nick-90b8751d4e2da4738956b98f4025f74c.jpg";